import Vue from "vue";

const context = require.context("./", false, /^(?!.*index).+\.js$/);

context.keys().forEach((key) => {
  const filterFn = context(key).default;
  const name = key.replace("./", "").replace(".js", "");
  if (typeof filterFn === "function") {
    Vue.filter(name, filterFn);
  } else if (filterFn && typeof filterFn === "object") {
    Object.entries(filterFn).forEach(([n, fn]) => Vue.filter(n, fn));
  }
});
